

const getCookie = (name) => {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
        const [key, value] = cookie.split("=");
        if (key === name) return value;
    }
    return null;
}
const setCookie = (content) => {
    document.cookie = content;
}

export const CookieStorage = {
    getCookie,
    setCookie
};